const accordionHeading = document.querySelectorAll('[js-accordion-heading]');
const accordionBody = document.querySelectorAll('[js-accordion-item]');
accordionHeading.forEach(eventElement => {
    eventElement.addEventListener("click", function () {
        const activeElement = this.parentElement;
        const storeElement = activeElement.classList.contains('active');
        accordionBody.forEach(removeElement => {
            removeElement.classList.remove('active');
            const maxHeight = removeElement.querySelector('.custom-faq__answer--wrap');
            maxHeight.style.maxHeight = '0'
        });
        if (!storeElement) {
            activeElement.classList.add('active');
            const maxHeight = activeElement.querySelector('.custom-faq__answer--wrap');
            const storeHeight = maxHeight.scrollHeight;
            maxHeight.style.maxHeight = storeHeight + 'px'
        }
    });
});